import * as Yup from 'yup';

import {
  EIV_CHAR_LENGTH,
  EIV_ENTRY_TYPE,
  TENANT_WITH_BIRTHDATE,
  VALIDATION_CONSTANTS,
} from 'global/constants';

import { areExpertContactsEnabled } from 'utils/FormUtils';
import { YFutureDate, YPastDate, YPhoneNumber } from 'utils/YupUtils';
import { getTenantId } from 'utils/tenantUtil';

export const YNEFIExpertValidation = (branchSelectionValues) =>
  Yup.object()
    .shape({
      lastName: Yup.string()
        .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
        .max(EIV_CHAR_LENGTH.EXPERT_NAME, VALIDATION_CONSTANTS.TOO_LONG)
        .required(VALIDATION_CONSTANTS.MANDATORY),
      birthdate: Yup.string().when([], {
        is: () => TENANT_WITH_BIRTHDATE.includes(getTenantId()),
        then: YPastDate.required(VALIDATION_CONSTANTS.MANDATORY),
      }),
      firstName: Yup.string()
        .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
        .max(EIV_CHAR_LENGTH.EXPERT_NAME, VALIDATION_CONSTANTS.TOO_LONG)
        .required(VALIDATION_CONSTANTS.MANDATORY),
      netzportalEmail: Yup.string().when([], {
        is: () => areExpertContactsEnabled,
        then: (schema) =>
          schema
            .email(VALIDATION_CONSTANTS.INVALID_EMAIL)
            .required(VALIDATION_CONSTANTS.MANDATORY),
        otherwise: (schema) => schema.email(VALIDATION_CONSTANTS.INVALID_EMAIL).optional(),
      }),
      telefon: Yup.lazy((value) => {
        if (value !== undefined && value !== '' && areExpertContactsEnabled) {
          return YPhoneNumber;
        }
        return Yup.string().nullable().optional();
      }),
      newEmail: Yup.string().email(VALIDATION_CONSTANTS.INVALID_EMAIL).optional(),
      confirmEmail: Yup.string()
        .optional()
        .when('netzportalEmail', {
          is: (val) => Boolean(val) && areExpertContactsEnabled,
          then: (schema) =>
            schema
              .required('Bitte bestätigen Sie die E-Mail-Adresse')
              .oneOf([Yup.ref('netzportalEmail')], 'Die E-Mail-Adressen stimmen nicht überein'),
        }),
      isExpertEnergyActive: Yup.boolean(),
      isExpertGasActive: Yup.boolean(),
    })
    .test('checkAtLeastOneBranchSelected', null, (obj) => {
      if (obj.isExpertEnergyActive || obj.isExpertGasActive) {
        return true;
      }
      return new Yup.ValidationError(
        'Wählen Sie mindestens eine Sparte aus.',
        null,
        'noBranchSelected'
      );
    });
